var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAddGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0C957BBC-5A62-429B-AE6D-F24C248D4F63") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S\\u0101kums",
    transform: "translate(-397.000000, -238.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-content",
    transform: "translate(240.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blocks",
    transform: "translate(20.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(137.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "viewbox",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6,6 C18.9665,6 21.1532631,7.00049298 22.8336534,8.74325897 L23,8.921 L23.1668851,8.74362103 C24.7763152,7.07336832 26.8518628,6.08468413 29.1051137,6.00519352 L29.4,6 L39,6 C40.6568542,6 42,7.34314575 42,9 L42,33 C42,34.6568542 40.6568542,36 39,36 L31,36 C28.7584227,36 27.06069,36.7822218 25.6996346,38.4205551 L25.5023284,38.6709072 C25.3517131,38.8959032 25.1708471,39.0982121 24.9398994,39.2944634 L24.8306147,39.3815849 C24.2983726,39.7990234 23.6536889,40.010182 23.0105656,40.004163 C22.4873206,40.009317 21.9714683,39.8784406 21.4437308,39.5708747 L21.1077716,39.3331054 L20.9182709,39.1676928 C20.7564315,39.0160269 20.6180345,38.8528867 20.5271427,38.7111258 C19.1090454,36.8617003 17.3525697,36 15,36 L7,36 C5.34314575,36 4,34.6568542 4,33 L4,9 C4,7.34314575 5.34314575,6 7,6 L16.6,6 Z M16.6,8 L7,8 C6.44771525,8 6,8.44771525 6,9 L6,33 C6,33.5522847 6.44771525,34 7,34 L15,34 C17.8667713,34 20.1484596,35.0691333 21.9568742,37.299976 L22,37.355 L22.0009424,10.8371067 C20.6746615,9.11050393 18.8556516,8.09136356 16.8720197,8.00585243 L16.6,8 Z M39,8 L29.4,8 C27.3109617,8 25.3858117,9.03195305 24.0007531,10.8367211 L24,37.348 L24.140155,37.1687869 C25.8347394,35.1279054 27.9885094,34.0851624 30.6629753,34.0050083 L31,34 L39,34 C39.5522847,34 40,33.5522847 40,33 L40,9 C40,8.44771525 39.5522847,8 39,8 Z",
    id: "icon",
    fill: "#667380",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "additional",
    transform: "translate(32.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "background",
    fill: "#FFFFFF",
    cx: 7,
    cy: 7,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,0 C10.8659932,0 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 Z M7,4 C6.44771525,4 6,4.44771525 6,5 L6,6 L5,6 C4.48716416,6 4.06449284,6.38604019 4.00672773,6.88337887 L4,7 C4,7.55228475 4.44771525,8 5,8 L6,8 L6,9 C6,9.51283584 6.38604019,9.93550716 6.88337887,9.99327227 L7,10 C7.55228475,10 8,9.55228475 8,9 L8,8 L9,8 C9.51283584,8 9.93550716,7.61395981 9.99327227,7.11662113 L10,7 C10,6.44771525 9.55228475,6 9,6 L8,6 L8,5 C8,4.48716416 7.61395981,4.06449284 7.11662113,4.00672773 L7,4 Z",
    id: "icon",
    fill: "#0883EF"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddGroup);
export default __webpack_public_path__ + "static/media/ic-add-group.530bbb1b930015d0ea4f3dbd62f8b0d1.svg";
export { ForwardRef as ReactComponent };